import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginWithGoogle } from "../../Redux/actions/authActions";
import { toast } from "react-toastify";
import { hasUserFilledSurvey } from "../../Redux/actions/commonActtion";
import { Scrollx_animate, scrollxLogo } from "../../assets/icons";
import LoaderGlobal from "../../Components/Loader/LoaderGlobal";
import "../Login/login.css";

let body = {
  googleToken: "",
};

const SignUpWithGoogle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [signInLoading, setSignInLoading] = useState(false);

  const handleSuccess = async (credentialResponse) => {
    setSignInLoading(true);
    if (credentialResponse?.credential) {
      body.googleToken = credentialResponse?.credential;
      const res = await dispatch(loginWithGoogle(body));
      if (res?.success) {
        localStorage.setItem("signedInWithGoogle", "true");
        const filled = await hasUserFilledSurvey();
        localStorage.setItem("userFilledSurvey", JSON.stringify(filled === true));
        setSignInLoading(false);
        navigate(filled === true ? "/dashboard" : "/new_user_survey");
      } else {
        setSignInLoading(false);
        alert("something wrong ");
      }
    }
  };

  const handleError = () => {
    alert("Login Failed");
  };

  return (
    <>
      {signInLoading && (
        <div className="modal-overlayLoaderGoogle">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="120px"
            height="120px"
            alt=""
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Sign in with Google...</p>
        </div>
      )}

      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap
        type="standard"
        theme="filled_blue"
        size="large"
        text="continue_with"
        shape="rectangular"
        width="400"
      />
    </>
  );
};

export default SignUpWithGoogle;
